angular.module('dpw.services').factory('developerService', ['$q', 'api', 'popupUtil', 'mixpanelService', function ($q, api, popupUtil, mixpanelService) {
    return {

        isPrimaryContact: function (id) {
            return $q(function (resolve, reject) {
                if (RCDPW.isAdminSite) {
                    reject();
                }
                api.call(api.myAccount.developers.isPrimaryContact(id), function (data) {
                    resolve(data.result);
                });
            });
        },

        getDeveloper: function (developerId) {
            if (RCDPW.isAdminSite && !developerId) {
                return $q.reject();
            }

            return $q.resolve()
                .then(function () {
                    if (RCDPW.isAdminSite) {
                        return api.call(api.admin.developers.get({id: developerId}), angular.noop, angular.noop);
                    }

                    return api.call(api.myAccount.developers.get({id: developerId}), angular.noop, angular.noop);
                })
                .then(function (res) {
                    return res.developer;
                })
                .catch(function (reason) {
                    var errorCode = _.get(reason, 'data.errors[0].errorCode');

                    // DPW-3359
                    if (!RCDPW.isAdminSite && errorCode === 'OAU-213') {
                        popupUtil.ok({
                            content: RCDPW.Lang.MyAccount.TOKEN_NOT_FOUND,
                            btnName: 'Login',
                            showCloseBtn: false,
                            callback: function () {
                                api.call(api.logout(), function () {
                                    mixpanelService.reset();
                                    window.location.href = '/login';
                                });
                            }
                        });

                        return;
                    }

                    _.result(reason, 'defaultErrorHandler');
                });
        },

        admin: {
            searchDevelopers: function (options, paging) {
                return $q(function (resolve) {
                    api.call(api.admin.developers.search(options, paging), function (data) {
                        resolve(data);
                    });
                });
            },
            getDevelopers: function (options, paging) {
                return $q(function (resolve) {
                    api.call(api.admin.developers.list(options, paging), function (data) {
                        resolve(data);
                    });
                });
            }
        }

    };
}]);
